// Module
var code = "<div class=city-header><p class=animate ng-if=\"$ctrl.search.state.$state() === 'LOADED'\"><strong>{{$ctrl.search.numSpaces}}</strong>&nbsp;{{$ctrl.pluralize('space', $ctrl.search.numSpaces)}} in&nbsp;<strong>{{$ctrl.search.total}}</strong>&nbsp;{{$ctrl.pluralize('venue', $ctrl.search.total)}}</p></div>";
// Exports
module.exports = code;